import { TurnType } from '../../types/enums';

/**
 * DiagnosticTag - Small colored tag showing a turn's classification
 * (搓雪 / 走刃 / 卡宾). Color-coded to match the status palette:
 *   Skidding → bad (red)
 *   Edging   → ok  (amber)
 *   Carving  → good (green)
 */
interface DiagnosticTagProps {
  type: TurnType;
  /** When false, only the colored dot is rendered (label hidden). */
  showLabel?: boolean;
}

const TAG_CONFIG: Record<TurnType, { label: string; color: string; bg: string }> = {
  [TurnType.Skidding]: {
    label: '搓雪',
    color: 'var(--status-bad)',
    bg: 'rgba(239, 68, 68, 0.15)',
  },
  [TurnType.Edging]: {
    label: '走刃',
    color: 'var(--status-ok)',
    bg: 'rgba(245, 158, 11, 0.15)',
  },
  [TurnType.Carving]: {
    label: '卡宾',
    color: 'var(--status-good)',
    bg: 'rgba(16, 185, 129, 0.15)',
  },
};

export default function DiagnosticTag({
  type,
  showLabel = true,
}: DiagnosticTagProps) {
  const config = TAG_CONFIG[type];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: 'var(--fs-xs)',
        fontWeight: 'var(--fw-medium)',
        padding: '1px 6px',
        borderRadius: 'var(--radius-sm)',
        background: config.bg,
        color: config.color,
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          width: 5,
          height: 5,
          borderRadius: '50%',
          background: config.color,
          flexShrink: 0,
        }}
      />
      {showLabel && config.label}
    </span>
  );
}
